export default __webpack_public_path__ + "img/5d7f74e72269bac590a933a31654e40a.svg";